import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  inject,
  Input,
} from '@angular/core';
import { InputContext } from '@app/user-content/user-input/user-input.model';
import { Observable } from 'rxjs';
import { ViewModel } from '../../event.model';
import { EventCatalogFacade } from '../../services/catalog/event-catalog-facade.service';
import { FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'dgx-event-catalog',
  templateUrl: './event-catalog.component.html',
  // see ngx-app\src\styles\components\_form-wrapper.scss for style
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [EventCatalogFacade],
})
export class EventCatalogComponent implements OnInit {
  @Input() public context: InputContext;

  public vm$: Observable<ViewModel>;
  public form$: Observable<FormGroup>;

  private facade = inject(EventCatalogFacade);

  public ngOnInit() {
    this.vm$ = this.facade.initializeViewModel(this.context);
    this.form$ = this.facade.initializeForm(this.context);
  }
}
